import React, { useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { Button } from "@mui/material";
import OptionsPaymentDate from "./OptionsPaymentDate";

const PaymentDate = ({ optionTermId }) => {
  const [open, setOpen] = useState(false);
  return (
    <GlobalDialog
      title={"Options date"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      fullWidth
      maxWidth={"md"}
      popupButton={
        <Button
          size="small"
          sx={{
            color: "white",
            background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
            borderRadius: 4,
          }}
          onClick={() => setOpen(true)}
        >
          Check Payment Date
        </Button>
      }
      content={
        <>{open ? <OptionsPaymentDate optionTermId={optionTermId} /> : null}</>
      }
    />
  );
};

export default PaymentDate;
